// extracted by mini-css-extract-plugin
module.exports = {"recommendSliderTitle":"recommendSliderTitle","recommendSliderTitle_jobCount":"recommendSliderTitle_jobCount","recommendSliderUpdateDate":"recommendSliderUpdateDate"};